// extracted by mini-css-extract-plugin
module.exports = {"main":"LoadingAnimation_main__3-uCr","lds_ring":"LoadingAnimation_lds_ring__1_gGp"};